import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const serviceDeskServiceDetailsWithoutProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-service-details-without-project',
	path: '/jira/servicedesk/services/:serviceAri',
};
